$ = require 'jquery'
ActionListView = require 'views/action/action-list-view'
AddChecklistMenu = require 'views/checklist/add-checklist-menu'
Alerts = require 'views/lib/alerts'
AttachmentHelpers = require 'views/attachment/helpers'
AttachmentThumbView = require 'views/attachment/attachment-thumb-view'
AttachmentTypePickerView = require 'views/card/attachment-type-picker-view'
AttachmentViewer = require 'views/internal/attachment-viewer'
Auth = require 'db/auth'
AutoInsertionView = require 'views/internal/autocomplete/auto-insertion-view'
AutoMentionerView = require 'views/internal/autocomplete/auto-mentioner-view'
Browser = require 'lib/browser'
TrelloCompleterView = require 'views/internal/autocomplete/trello-completer-view'
CardCopyView = require 'views/card/card-copy-view'
CardDetailMoreMenuView = require 'views/card/card-detail-more-menu-view'
CardLabelSelectView = require 'views/label/card-label-select-view'
{ maybeDisplayCardLimitsError } = require 'views/card/card-limits-error'
CardMemberSelectView = require 'views/card/card-member-select-view'
CardMoveView = require 'views/card/card-move-view'
CardViewHelpers = require 'views/card/card-view-helpers'
ChecklistView = require 'views/checklist/checklist-view'
CompleterUtil = require 'views/internal/autocomplete/completer-util'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
DatePickerView = require 'views/card/date-picker-view'
Dates = require 'lib/dates'
Dialog = require 'views/lib/dialog'
require 'views/internal/data-transfer/drag-drop-events'
DragSort = require 'views/lib/drag-sort'
DueDateHelpers = require 'views/internal/due-date-helpers'
EditableView = require 'views/internal/editable-view'
FormattingHelpView = require 'views/card/formatting-help-view'
getExperiment = require 'lib/experiments/simple-test'
Hearsay = require 'hearsay'
InProgressAttachmentView = require 'views/attachment/in-progress-attachment'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
Label = require 'models/label'
LabelKeyHelper = require 'views/label/label-key-helper'
Layout = require 'views/lib/layout'
LegacyPowerUps = require 'data/legacy-power-ups'
LimitExceeded = require 'views/attachment/attachment-limit-exceeded-error'
MemberState = require 'view-models/member-state'
MembersVotedView = require 'views/member/members-voted-view'
ModelCache = require 'db/model-cache'
ModelLoader = require 'db/model-loader'
Monitor = require 'lib/monitor'
PluginCardButtonsView = require 'views/plugin/plugin-card-buttons-view'
PluginCardDetailBadgesView = require 'views/plugin/plugin-card-detail-badges-view'
PluginModelSerializer = require 'views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PluginSectionView = require 'views/plugin/plugin-section-view'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
simpleTest = require 'lib/experiments/simple-test'
StickerView = require 'views/stickers/sticker-view'
Storage = require 'lib/storage'
TFM = require 'lib/markdown/tfm'
TrelloBoardAttachment = require 'views/attachment/trello-board-attachment'
TrelloCardAttachment = require 'views/attachment/trello-card-attachment'
TFM = require 'lib/markdown/tfm'
Util = require 'lib/util'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
f = require 'effing'
friendlyLinks = require 'views/internal/friendly-links'
log = require 'debug/log'
mixin = require 'lib/mixin'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
moment = require 'moment'
l = require 'lib/localize'
localizeCount = require 'lib/localize-count'
pastedFileName = require 'views/internal/pasted-file-name'
warnIfFileTooLarge = require 'views/internal/warn-if-file-too-large'
ninvoke = require 'lib/util/ninvoke'
cardDetailTemplate = require 'views/templates/card_detail'
cardDetailListTemplate = require 'views/templates/card_detail_list'
cardDetailAddButtonTemplate = require 'views/templates/card_detail_add_button'
cardDetailSubscribeTemplate = require 'views/templates/card_detail_subscribe'
labelTemplate = require 'views/templates/label'
cardDetailVoteBtnSidebarTemplate = require 'views/templates/card_detail_vote_btn_sidebar'
editInProgressTemplate = require 'views/templates/edit_in_progress'
removeAllRanges = require 'lib/util/removeAllRanges'
parseTrelloUrl = require 'lib/util/url/parse-trello-url'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'

attachmentAsMarkdown = (attachment) ->
  "[#{ attachment.get('name') }](#{ attachment.get('url') }) "

module.exports = mixin AutoInsertionView, CompleterUtil, CardViewHelpers, class CardDetailView extends EditableView
  className: 'card-detail-window u-clearfix'
  defaultActionLimit: 50
  maxActionLimit: 1000
  maximumCommentLength: 16384 # This is the most the API accepts for a string
  maxDescLength: 1800 # When to truncate the desc and show "Show full description."

  addListCloseEventListener: ->
    # Archived lists may be loaded later so listening to @model.getList() won't
    # work until the data is loaded.

    # Clean up any old event listeners.

    idOldList = @model.previous('idList')

    if idOldList
      @stopListening(@modelCache, "add:List:#{ idOldList }")

      oldList = @modelCache.get('List', idOldList)
      @stopListening(oldList, 'change:closed')

    # Add new listeners.

    listenToClose = =>
      @renderArchivedDebounced()
      @listenTo @model.getList(),
        'change:closed': @renderArchivedDebounced

    if @model.getList()
      listenToClose()
    else
      @listenToOnce @modelCache, "add:List:#{ @model.get('idList') }", listenToClose

    return

  initialize: ->

    @fEditingName = false

    @makeDebouncedMethods 'render',
      'renderAddAttachments'
      'renderAddChecklists'
      'renderCover'
      'renderStickers'
      'renderName'
      'renderDescription'
      'renderArchived'
      'renderLabels'
      'renderList'
      'renderVotes'
      'renderDueDate'
      'renderSubscribe'
      'renderAttachments'
      'renderMembers'
      'renderAging'

    @listenTo @model,
      'change:name': @renderNameDebounced
      'change:desc': @renderDescriptionDebounced
      'change:closed': @renderArchivedDebounced
      'change:labels': @renderLabelsDebounced
      'change:limits': =>
        @renderAddAttachmentsDebounced()
        @renderAddChecklistsDebounced()
      'change:idList': =>
        @renderListDebounced()
        @addListCloseEventListener()
      'change:idMembersVoted': @renderVotesDebounced
      'change:due change:dueComplete': @renderDueDateDebounced
      'change:subscribed': @renderSubscribeDebounced
      'change:dateLastActivity': @renderAgingDebounced
      'change:idAttachmentCover': ->
        @renderCoverDebounced()
      'destroy': @closeDialog

    @addListCloseEventListener()

    @listenTo @model.labelList, 'add remove reset change', =>
      @renderLabelsDebounced()

    @listenTo @model.memberList,
      'add remove reset': @renderMembersDebounced

    @listenTo @model.memberVotedList,
      'add remove reset': @renderVotesDebounced

    @listenTo @model.checklistList,
      'add reset': @renderChecklists
      'remove': @removeChecklist
      'sort': @sortChecklists

    @listenTo @model.attachmentList,
      'add remove reset': @renderAttachmentsDebounced
      'sort': @renderAttachments

    @listenTo @model.stickerList,
      'add remove reset change sort': @renderStickersDebounced

    @listenTo @model.memberEditingList,
      'add remove reset change:action': @renderEditing

    board = @model.getBoard()
    @listenTo board,
      'change:labelNames': @renderLabelsDebounced
      'change:labels': @renderLabelsDebounced
      'change:limits': @renderAddChecklistsDebounced
      'change:prefs': (board) ->
        changed = (pref) ->
          board.get('prefs')?[pref] != board.previous('prefs')?[pref]

        # Try to be as specific as possible about what we rerender
        if changed('cardCovers')
          @renderCover()

        # Re-rendering the whole card will mess up in-progress edits, so don't
        # ever do that if there is an edit in progress
        requiresFullRender =
          changed('cardAging') || changed('comments') || changed('voting')
        if requiresFullRender && @$('.editing').length == 0
          @renderDebounced()

    @subscribe pluginsChangedSignal(board, @model), => @renderAttachments()

    @getData()

    @numAttachmentsProcessing = @slot(0)
    @numTrelloAttachmentsProcessing = @slot(0)
    @watch 'numAttachmentsProcessing', @renderAttachmentsDebounced
    @watch 'numTrelloAttachmentsProcessing', @renderAttachmentsDebounced

    # It's possible, if a card was just created, that it won't have the
    # desc specified yet
    @fHideFullDescription = @model.get('desc')?.length > @maxDescLength

    @actionListView = @collectionSubview ActionListView, @model.actionList,
      renderOpts:
        context: @model
        compact: false

    @markNotificationsReadOnActive()
    @listenTo ModelCache, 'add:Notification', @markNotificationsReadOnActive

    @listenTo Layout, 'cancelEdits', @saveCommentDraft
    $(window).on "beforeunload.CardDetailView-#{@model.cid}", f(@, 'saveCommentDraft', true)

    @pluginThumbTrackCache = {}

    return

  remove: ->
    @saveCommentDraft(true)
    $(window).off ".CardDetailView-#{@model.cid}"
    super
    return

  markNotificationsReadOnActive: ->
    if Monitor.getStatus() != 'active' || Monitor.getHidden()
      @listenToOnce Monitor, "setStatus visibilitychange", @markNotificationsReadOnActive
    else
      @markRelatedNotificationsRead()
    return

  markRelatedNotificationsRead:  ->
    isRelatedAndUnread = (notification) =>
      notification.get('unread') &&
      notification.get('data')?.card?.id == @model.id
    for notification in @modelCache.all('Notification') when isRelatedAndUnread(notification)
      notification.markRead()
    return

  events:
    # sidebar
    'click .js-edit-labels': 'editLabelsSidebar'
    'click .js-change-card-members': 'changeMembersSidebar'
    'click .js-add-checklist-menu': 'addChecklistSidebar'
    'click .js-add-due-date': 'dueDateSidebar'
    'click .js-attach': 'openAttachPicker'
    'click .js-attach-trello-attachment': 'openAttachTrelloPicker'

    'click .js-move-card': 'moveCard'
    'click .js-copy-card': 'copyCard'
    'click .js-subscribe': 'subscribeToCard'
    'click .js-unsubscribe': 'unsubscribeFromCard'
    'click .js-vote': 'vote'
    'click .js-unvote': 'unvote'

    'click .js-archive-card': 'archiveCard'
    'click .js-unarchive-card': 'unarchiveCard'
    'click .js-delete-card': 'deleteCardSidebar'

    'click .js-more-menu': 'showMoreMenu'

    # title
    'keydown  .js-card-detail-title-input': 'nameKeyDownEvent'
    'focus    .js-card-detail-title-input': (e) ->
      @startNameEditing({ focus: false })

    'blur     .js-card-detail-title-input': 'stopNameEditing'

    # main col
    'click .js-open-card-cover-in-viewer': 'openCoverInViewer'
    'click .js-open-move-from-header': 'openMoveFromHeader'
    'click .js-details-edit-members': 'editMembersMain'
    'click .js-details-edit-labels': 'editLabelsMain'
    'click .js-edit-label .card-label': 'editLabelsMainSingleLabel'
    'click .js-details-edit-due-date': 'showDueDateBadgeMenu'
    'click .js-details-toggle-due-date-complete': 'toggleDueDateComplete'
    'click .js-show-votes': 'showVotes'
    'click .js-edit-desc': 'editDesc'
    'click .js-desc-content.is-hide-full': 'showFullDescription'
    'click .js-member-on-card-menu': 'openMemberOnCardMenu'
    'click .js-format-help': 'openFormatHelp'

    'click .js-view-some-attachments': 'showFewerAttachments'
    'click .js-view-all-attachments': 'showMoreAttachments'
    'click .js-view-some-trello-attachments': 'showFewerTrelloAttachments'
    'click .js-view-all-trello-attachments': 'showMoreTrelloAttachments'
    'click .js-show-all-actions': 'showAllActions'

    # comments
    'keydown .js-new-comment-input': 'keydownCommentEvent'
    'input .js-new-comment-input': 'commentInputEvent'
    'mutated .js-new-comment-input': 'commentInputEvent'
    'click .js-add-comment:not(:disabled)': 'submitComment'
    'click .js-comment-subscribe': 'subscribeOnComment'
    'click .js-attach-comment': 'attachComment'
    'click .js-truncate-comment': 'truncateComment'
    'click .js-new-comment': 'inputComment'
    'focus .js-new-comment-input': 'inputComment'
    'keyup .js-new-comment-input': 'keyAutoMention'
    'click': 'clickAwayFromComment'

    'click .js-new-comment .js-comment-add-attachment': 'commentAddAttachment'
    'click .js-new-comment .js-comment-mention-member': 'commentMentionMember'
    'click .js-new-comment .js-comment-add-emoji': 'commentAddEmoji'
    'click .js-new-comment .js-comment-add-card': 'commentAddCard'

    'click .js-show-details': 'showDetails'
    'click .js-hide-details': 'hideDetails'

    'click a[href]': 'interceptHighlightLink'

    # attachments
    'dd-enter:files': 'dragenter'
    'dd-leave:files': 'dragleave'
    'dd-drop:files': 'dropFiles'
    'dd-enter:url': 'dragenter'
    'dd-leave:url': 'dragleave'
    'dd-drop:url': 'dropUrl'
    'userinput-paste:files': 'dropFiles'
    'userinput-paste:url': 'dropUrl'

    # checklist sort
    'sortstop .js-checklist-list': 'sortStop'

    'sortstop .js-attachment-list': 'sortStopAttachments'

    'shortcut': 'shortcut'

    'replyToAction': 'replyToAction'
    'replyToAllAction': 'replyToAllAction'

  shortcut: (key) ->
    board = @model.getBoard()
    editable = @model.editable()
    loggedIn = Auth.isLoggedIn()

    switch key
      when Keys.Space
        if editable && board.hasActiveMembership(Auth.me())
          @model.toggleMember(Auth.myId())
          ["Space - Toggle Assigning Self", "Card Detail"]

      when Keys.A, Keys.M
        if editable
          @changeMembersSidebar()
          ["A - Assign Members", "Card Detail"]

      when Keys.E
        if editable
          @editDesc()
          ["E - Edit Description", "Card Detail"]

      when Keys.L
        if editable
          @_openEditLabelsSidebar({ hideOnSelect: false })
          ["L - Edit Labels", "Card Detail"]

      when Keys.D
        if editable
          if @model.get('due')?
            @showDueDateBadgeMenu()
          else
            @dueDateSidebar()
          ["D - Due Dates", "Card Detail"]

      when Keys.C
        if editable
          @archiveCard()
          ["C - Archive Card"]

      when Keys.T
        if editable
          @editTitle()
          "T - Edit Title"

      when Keys.AngleRight, Keys.Period
        if editable
          @model.moveToNextList(if key == Keys.AngleRight then 'top' else 'bottom')
          "> - Move to Next List"

      when Keys.AngleLeft, Keys.Comma
        if editable
          @model.moveToPrevList(if key == Keys.AngleLeft then 'top' else 'bottom')
          "< - Move to Previous List"

      when Keys._0, Keys._1, Keys._2, Keys._3, Keys._4, \
           Keys._5, Keys._6, Keys._7, Keys._8, Keys._9
        if editable
          fxNoUniqueLabel = (color) =>
            @_openEditLabelsSidebar({ searchInit: color, hideOnSelect: true })
          LabelKeyHelper.setLabelFromKey(key, @model, fxNoUniqueLabel)
          "0-9 - Toggle Specific Label"

      when Keys.V
        if board.canVote(Auth.me())
          @model.toggleVote()
          "V - Vote"

      when Keys.S
        if loggedIn
          subscribed = @model.get('subscribed')
          @model.subscribe(!subscribed)
          ["S - Subscribe", if subscribed then "Unsubscribe" else "Subscribe"]

      when Keys.J
        if (nextCard = @model.nextCard())?
          Controller.showCardDetail(nextCard, { isNavigating: true })
          "J - Down"

      when Keys.K
        if (prevCard = @model.prevCard())?
          Controller.showCardDetail(prevCard, { isNavigating: true })
          "K - Up"

  incrementNumAttachmentsProcessing: (count = 1) ->
    @numAttachmentsProcessing.update f.add(count)

  decrementNumAttachmentsProcessing: (count = 1) ->
    @numAttachmentsProcessing.update f.sub(count)

   incrementNumTrelloAttachmentsProcessing: (count = 1) ->
    @numTrelloAttachmentsProcessing.update f.add(count)

  decrementNumTrelloAttachmentsProcessing: (count = 1) ->
    @numTrelloAttachmentsProcessing.update f.sub(count)

  getData: ->
    @loading = true
    @$('.js-loading-card-actions').show()

    @waitForId @model, =>
      limit = if @fShowAllActions then @maxActionLimit else @defaultActionLimit
      Promise.try =>
        if !Auth.isLoggedIn() || Auth.me().getShowDetails()
          ModelLoader.loadCardDetails @model.id, limit
        else
          ModelLoader.loadCardHideDetails @model.id, limit
      .finally =>
        @loading = false
        @$('.js-loading-card-actions').hide()
      .then =>
        @renderShowAllActionsButton()
        @scrollToHighlight()
      .done()

    return

  scrollToHighlight: ->
    lastScroll = Date.now()

    cancelAnimationFrame(@scrollInterval)
    snapTo = null

    updateScroll = =>
      if Dialog.scrolledSince(lastScroll)
        return

      if (el = @$('.mod-highlighted')[0])?
        if !snapTo
          rect = el.getBoundingClientRect()
          if rect.top < 0
            snapTo = 'top'
          else if rect.top + rect.height > window.innerHeight
            snapTo = 'bottom'
          else
            snapTo = null


        if snapTo == 'top'
          el.scrollIntoView(true)
        else if snapTo == 'bottom'
          el.scrollIntoView(false)

        lastScroll = Date.now()

      @scrollInterval = @requestAnimationFrame(updateScroll)
      return

    updateScroll()
    return

  render: ->
    @fShowAllAttachments = false
    @fShowAllTrelloAttachments = false
    @fShowAllActions = false

    data = _.extend @model.toJSON(),
      canAttach: @model.canAttach()
      canComment: @model.getBoard().canComment(Auth.me())
      canVote: @model.getBoard().canVote(Auth.me())
      canSubscribe: Auth.isLoggedIn()
      canToggleDetails: Auth.isLoggedIn()
      hasAttachments: @model.attachmentList.length > 0
      me: Auth.me().toJSON()
      loading: @loading
      editable: @model.editable()
      commentAndSubscribe: getExperiment('commentAndSubscribe').get('enabled')
      subscribeOnComment: Auth.me().isSubscribeOnCommentEnabled()

    data.showActions = data.canVote || data.canSubscribe

    @$el.html cardDetailTemplate(data)

    @actionListView.setElement @$('.js-list-actions')[0]

    @commentInput = @$('.js-new-comment-input')[0]

    @renderCover()
    .renderStickers()
    .renderName()
    .renderDescription()
    .renderList()
    .renderActionList()
    .renderMembers()
    .renderArchived()
    .renderChecklists()
    .renderSubscribe()
    .renderVotes()
    .renderDueDate()
    .renderAttachments()
    .renderAddAttachments()
    .renderAddChecklists()
    .renderLabels()
    .renderAging()
    .renderEditing()
    .renderPluginBadges()
    .renderPluginButtons()

    if data.canComment
      @recallDrafts()

    @$('.js-card-detail-title-input').autosize(append: false)
    @$('.js-new-comment-input').autosize()

    # So, Chrome appears to have a crazy rendering bug that makes the
    # card detail appear to randomly jump to different scroll positions.  It
    # isn't clear exactly what's causing this issue, but bug reports like
    # https://bugs.chromium.org/p/chromium/issues/detail?id=581875
    # seem to indicate that position: fixed elements don't play nicely with
    # recent changes to how chrome does scrolling
    if Browser.browserStr !in ['chrome']
      @defer _.bind(@fixSidebar, @)

    Dates.update(@el)

    @

  _commentDraftKey: -> "draft_#{@model.id}_comment"

  recallDrafts: ->
    commentDraftText = Storage.get @_commentDraftKey()
    if commentDraftText
      @$('.js-new-comment-input').val(commentDraftText)
    @renderCommentSubmitAbility()
    super

  saveCommentDraft: (didCloseCard = false) ->
    $input = @$('.js-new-comment-input')
    if $input.length == 0
      return
    commentText = $input.val()
    if commentText
      Storage.set @_commentDraftKey(), commentText
      if didCloseCard
        track('Card Detail', 'Comment', 'Save Comment Draft')
        trackUe('Card Detail', 'save', 'comment draft', '', '', 'when closing a card', '')
    else
      Storage.unset @_commentDraftKey()
    return

  saveCardName: ->
    $input = @$('.js-card-detail-title-input')
    newValue = $input.val()
    name = @model.get('name')

    # remove whitespace
    newValue = newValue.replace(/\s+/g, ' ').trim()

    # if it's the same name, don't save
    if newValue == name
      return

    # if it's too long, don't save
    if newValue.length > 16384
      return

    # can't be empty.
    if newValue.trim().length == 0
      return

    # We should handle the returned `err` someday…
    @model.update 'name', newValue

    return

  nameKeyDownEvent: (e) ->

    if Keyboard.getKey(e) == Keys.Enter
      Util.stop(e) # prevents new lines
      @stopNameEditing()

    if Keyboard.getKey(e) == Keys.Escape
      Util.stop(e) # don't close the overlay…
      @stopNameEditing()

    return

  startNameEditing: (options = {}) ->
    if !@fEditingName
      $input = @$('.js-card-detail-title-input')

      @fEditingName = true
      $input.addClass('is-editing')

      if options.focus
        $input.focus().select()

    return

  stopNameEditing: (e) ->

    if @fEditingName
      @fEditingName = false

      $input = @$('.js-card-detail-title-input').removeClass('is-editing')
      # We previously only blurred the $input if it looked like it had focus,
      # but this was problematic.
      #
      # If you switch tabs in Chrome by clicking on another tab and then come
      # back to this window, jquery will fire a `focusout` event, and we'd
      # end up in a state where the input still looked active even though
      # the edit had finished.
      $input.blur()
      removeAllRanges()
      @saveCardName()

    return

  setRelativeSidebarPos: ->
    @fFixed = false
    @fRelative = true

    @$('.window-sidebar').css
      left: ''
      top: ''
      position: 'relative'

  setFixedSidebarLeftPos: ->
    if @fFixed
      winLeft = parseFloat($('.window').offset().left)
      left = winLeft + $('.window').width() - @$('.window-sidebar').outerWidth()

      @$('.window-sidebar').css { left }

  setFixedSidebarPos: ->
    @fFixed = true
    @fRelative = false

    @setFixedSidebarLeftPos()

    @$('.window-sidebar').css
      top: 0
      position: 'fixed'

  fixSidebar: ->
    $overlay = $('.window-overlay').off('scroll.fixSidebar')

    @fFixed = false
    @fRelative = false

    m = parseInt $('.window').css('margin-top')
    s = parseInt @$('.window-sidebar').css('padding-top')

    updateSidebarPos = =>
      h = @$('.window-header').outerHeight()
      c = @$('.window-cover:visible').outerHeight() ? 0
      a = @$('.window-archive-banner:visible').outerHeight() ? 0

      sidebarScrollTop = m + h + c + a + s

      # Don't fix the sidebar if the window is shorter than it (you need to be
      # able to scroll to get at the bottom of the sidebar)
      if (($overlay.scrollTop() <= sidebarScrollTop) ||
          WindowSize.fSmall ||
          @$('.window-sidebar').height() > $(window).height())
        if !@fRelative
          @setRelativeSidebarPos()
          return

      else
        if !@fFixed
          @setFixedSidebarPos()
          return

    throttledUpdateSidebarPos = @throttle updateSidebarPos, 32

    $overlay.on 'scroll.fixSidebar', throttledUpdateSidebarPos

    return

  editDesc: (e) ->
    Util.stop(e)
    @showFullDescription()
    @edit('desc')
    return

  expandDesc: (e) ->
    Util.stop(e)
    @showFullDescription()
    @edit('desc', false)
    return

  showFullDescription: (e) ->
    @fHideFullDescription = false
    $('.js-desc-content').removeClass('is-hide-full')
    return

  editTitle: (e) ->
    @startNameEditing({ focus: true })
    return

  archiveCard: (e) ->
    @model.close()
    track("Card Detail", "Sidebar", "Archive Button")
    return

  unarchiveCard: (e) ->
    if maybeDisplayCardLimitsError(e, @model.getBoard(), @model.getList())
      return

    track("Card Detail", "Sidebar", "Re-Open Button")
    @model.reopen()
    return

  deleteCardSidebar: (e) ->
    Confirm.toggle 'delete card',
      elem: e.target
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        Dialog.hide()
        @model.destroy()
        track("Card", "Delete")

    track("Card Detail", "Sidebar", "Open Delete Confirm")
    return

  showMoreMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-more-menu')
      view: CardDetailMoreMenuView
      options: { @model, @modelCache }

    track("Card Detail", "Sidebar", "Open More Menu")
    return

  openCoverInViewer: (e) ->
    Util.stop(e)
    if !@showCover()
      return

    coverModel = @model.attachmentList.get(@model.get('idAttachmentCover'))
    if !AttachmentViewer.isActive()
      AttachmentViewer.show
        model: @model
        attachmentModel: coverModel
      track("Card Detail", "Open Attachment Viewer via Cover", coverModel.getType())
    return

  # move
  openMoveMenu: (elem) ->
    PopOver.toggle
      elem: elem
      view: CardMoveView
      options: { @model, @modelCache }

    return

  openMoveFromHeader: (e) ->
    Util.stop(e)
    @openMoveMenu(@$('.js-open-move-from-header'), 20)
    track("Card Detail", "Move Button (via Header)")
    return

  moveCard: (e) ->
    Util.stop(e)
    @openMoveMenu(@$('.js-move-card'), 35)
    track("Card Detail", "Sidebar", "Open Move Menu")
    return

  copyCard: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-copy-card')
      view: CardCopyView
      options: { @model, @modelCache }

    track("Card Detail", "Sidebar", "Open Copy Menu")
    return

  # labels
  openLabelsPopOver: (elem, options) ->
    PopOver.toggle
      elem: elem
      view: CardLabelSelectView
      options: _.extend({ @model, @modelCache }, options)
    return

  editLabelsMainSingleLabel: (e) ->
    Util.stop(e)
    @openLabelsPopOver(@$(e.target).closest('.card-label'))
    track("Card Detail", "Edit Labels Main Column - Single Label")
    return

  editLabelsMain: (e) ->
    Util.stop(e)
    @openLabelsPopOver(@$('.js-details-edit-labels'))
    track("Card Detail", "Edit Labels Main Column - Plus Button")
    return

  editLabelsSidebar: (e) ->
    Util.stop(e)
    track("Card Detail", "Sidebar", "Edit Labels Button")
    @_openEditLabelsSidebar()

  _openEditLabelsSidebar: (options) ->
    @openLabelsPopOver(@$('.js-edit-labels'), options)

  showVotes: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$('.js-show-votes')
      view: MembersVotedView
      options: { @model, @modelCache }

    track("Card Detail", "Header Vote Button")
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-detail-badge', LegacyPowerUps.voting)

    return

  doClicks: -> !DragSort.sorting

  showCover: ->
    @model.getBoard().getPref('cardCovers') && @model.hasCover()

  checkShowCover: ->
    hasCover = @showCover()
    hasStickers = @model.hasStickers()

    if hasCover
      @$('.js-card-cover-box')
        .removeClass('hide window-cover-stickers-only')
        .addClass('is-covered')
    else if hasStickers
      @$('.js-card-cover-box')
      .removeClass('hide is-covered')
      .addClass('window-cover-stickers-only')
    else
      @$('.js-card-cover-box').addClass('hide')

    return

  clearCover: ->
    @$('.js-card-cover-box').css
      'background-color': ''
      'background-image': ''

    btnClasses = [
      'dialog-close-button-light'
      'dialog-close-button-dark'
    ]

    $('.dialog-close-button').removeClass(btnClasses.join(' '))

  renderAddAttachments: ->
    disabled = !@model.canAttach()
    @$('.js-attach,.js-attach-trello-attachment,.js-attach-link')
      .toggleClass('disabled', disabled)

    @

  renderAddChecklists: ->
    cardOver = @model.isOverLimit('checklists', 'perCard')
    boardOver = @model.getBoard().isOverLimit('checklists', 'perBoard')
    disabled = cardOver || boardOver

    @$('.js-add-checklist-menu').toggleClass('disabled', disabled)

    @

  renderCover: ->
    @clearCover()

    if @showCover()
      attachmentCover = @model.attachmentList.get(@model.get('idAttachmentCover'))

      MIN_HEIGHT = 40
      MAX_HEIGHT = 160
      MAX_WIDTH = 730

      if attachmentCover?
        if Browser.isHighDPI()
          maxWidth = MAX_WIDTH * 2
          maxHeight = MAX_HEIGHT * 2
        else
          maxWidth = MAX_WIDTH
          maxHeight = MAX_HEIGHT

        previews = attachmentCover.get('previews')
        # Find the smallest preview that has a height that exceeds the maximum
        # height we'll give to a card cover, and doesn't exceed the width of a
        # card.
        preview = Util.previewBetween(previews, 0, maxHeight, maxWidth, Infinity) ?
          Util.biggestPreview(previews)

        if preview?
          coverImgUrl = preview.url
        else
          coverImgUrl = attachmentCover.get('url')

        $cardCoverBox = @$('.js-card-cover-box')

        if (edgeColor = attachmentCover.get('edgeColor'))?
          [r, g, b] = edgeColor.match(/[0-9a-f]{2}/ig).map (v) -> parseInt(v, 16)
          $cardCoverBox.css('background-color', "rgb(#{r}, #{g}, #{b})")

          avg = (r + g + b) / 3
          if avg > 150
            btnClass = 'dark'
          else if avg < 105
            btnClass = 'light'

          if btnClass?
            $('.dialog-close-button').addClass("dialog-close-button-#{btnClass}")

        height = Math.max(MIN_HEIGHT, Math.min(preview?.height ? MAX_HEIGHT, MAX_HEIGHT))

        @$('.js-card-cover-box')
          .css
            'background-image': "url(\"#{coverImgUrl}\")"
            'height': height
            'background-size':
              if preview?.height < height then 'initial' else 'contain'

    @checkShowCover()

    @

  renderPluginButtons: ->
    subview = @subview PluginCardButtonsView, @model
    @appendSubview subview, @$('.js-plugin-buttons')
    @

  renderPluginBadges: ->
    subview = @subview PluginCardDetailBadgesView, @model
    @appendSubview subview, @$('.js-plugin-badges')
    @

  renderStickers: ->
    $stickers = @$('.js-display-stickers').empty()
    stickers = @model.stickerList.models
    hasStickers = stickers.length > 0

    if hasStickers
      subviews = (@subview(StickerView, sticker, { board: @model }) for sticker in stickers)
      @appendSubviews(subviews, $stickers)

    @checkShowCover()

    @

  renderName: ->
    cardName = @model.get('name')
    boardName = @model.getBoard().get('name')

    # Hidden helper for accessibility and printing.
    @$('.js-title-helper').text(cardName)

    # Don't try and rerender while we're editing, we'll lose edits. Last
    # writer wins here.
    # We need to trigger a resize because the textarea won't resize for the
    # non-editing viewer.
    if !@fEditingName
      @$('.js-card-detail-title-input')
        .val(cardName)
        .trigger('autosize.resize', false)

    # Controller.title needs a *string*, not HTML
    Controller.title(l('card detail title', { cardName, boardName }, { raw: true }))
    @

  renderDescription: ->
    desc = @model.get('desc')
    descHtml = TFM.description.format(desc ? '', { textData: @model.get('descData') }).output
    $desc = @$('.js-card-desc')
    $desc.empty().append(descHtml).data('unmarkeddown', desc)
    friendlyLinks $desc[0], @model.getBoard()

    hasDesc = !/^\s*$/.test(descHtml)

    @$('.js-show-with-desc').toggleClass('hide', !hasDesc)
    @$('.js-hide-with-desc').toggleClass('hide', hasDesc)

    $('.js-desc-content').toggleClass('is-hide-full', @fHideFullDescription)

    @

  renderList: ->
    list = @model.getList()

    # It's possible that the list won't be loaded, if the card has been moved
    # to another board
    if list?
      @$('.js-current-list')
        .removeClass('hide')
        .html cardDetailListTemplate({ listName: list.get('name'), editable: @model.editable() })

    @

  renderArchived: ->
    isArchived = @model.get('closed') == true
    isInArchivedList = @model.getList()?.get('closed') == true

    showArchivedBanner = isArchived
    showArchivedListBanner = !isArchived && isInArchivedList

    # archive banner (or "in archived list" banner)
    @$('.js-archive-banner').toggleClass('hide', !showArchivedBanner)
    @$('.js-archived-list-banner').toggleClass('hide', !showArchivedListBanner)

    # sidebar buttons
    @$('.js-archive-card').toggleClass('hide', isArchived)
    @$('.js-unarchive-card').toggleClass('hide', !isArchived)
    @$('.js-delete-card').toggleClass('hide', !isArchived)

    @

  showAllActions: (e) ->
    @fShowAllActions = true
    @renderShowAllActionsButton()
    @getData()

  renderShowAllActionsButton: ->
    showDetails = !Auth.isLoggedIn() || Auth.me().getShowDetails()
    filteredActions = @model.actionList.filter (action) ->
      if showDetails
        true
      else
        action.isCommentLike()

    isMoreToShow = filteredActions.length >= @defaultActionLimit
    hideButton = @fShowAllActions || !isMoreToShow
    @$('.js-show-all-actions').toggleClass('hide', hideButton)

  renderActionList: ->
    showDetails = !Auth.isLoggedIn() || Auth.me().getShowDetails()
    @actionListView.setShowDetails(showDetails)
    @waitForId @model, => @actionListView.render()
    @$('.js-show-details').toggleClass('hide', showDetails)
    @$('.js-hide-details').toggleClass('hide', !showDetails)
    return @

  renderMembers: (e) ->
    $memberList = @$('.js-card-detail-members-list').empty()
    members = @model.memberList.filterDeactivated(model: @model.getBoard()).models
    memberHtml = (@getMemberOnCardHtml(member) for member in members).join("")
    $memberList.html(memberHtml)

    if @model.editable()
      $memberList.append(cardDetailAddButtonTemplate(klass: 'js-details-edit-members'))

    @$('.js-card-detail-members').toggleClass('hide', members.length == 0)

    @

  renderLabels: ->
    activeLabels = @model.getLabels().sort(Label.compare)

    $labels = @$('.js-card-detail-labels-list').empty()

    labelsHtml = for label in activeLabels
      data = @model.dataForLabel(label)
      data.extraClasses = ['mod-card-detail']
      if @model.editable()
        data.extraClasses.push('mod-clickable')
      labelTemplate(data)

    $labels.append(labelsHtml)

    if @model.editable()
      $labels
      .append(cardDetailAddButtonTemplate(klass: 'js-details-edit-labels'))
      .addClass('js-edit-label')

    @$('.js-card-detail-labels').toggleClass('hide', activeLabels.length == 0)

    @

  renderSubscribe: ->
    $subscribeSidebar = @$('.js-subscribe-sidebar-button')

    data =
      subscribed: @model.get('subscribed') || @model.get('badges')?.subscribed

    # EXPERIMENT: subscribeToWatchOrFollow
    subscribeToWatchOrFollow = getExperiment 'subscribeToWatchOrFollow'
    subscribeString = 'subscribe'
    subscribeAltString = 'subscribe-to-the-card-to-get-notifications-when-something-changes'

    if subscribeToWatchOrFollow?.inExperiment and subscribeToWatchOrFollow.get('variation') != 'control'
      subscribeString = subscribeToWatchOrFollow.get('variation')
      subscribeAltString = "#{subscribeString}-the-card"

    $subscribeSidebar.html cardDetailSubscribeTemplate(
      _.extend(data, {
        'subscribeString': subscribeString
        'subscribeAltString': subscribeAltString
      })
    )

    @$('.js-subscribed-indicator-header').toggleClass('hide', !data.subscribed)

    @

  renderAging: ->
    board = @model.getBoard()
    agingActive = board.isPowerUpEnabled('cardAging')

    $badge = @$('.js-card-detail-age-badge').removeClass @model.getAllAgingClasses()

    if agingActive
      data = @model.getAgingData()

      $badge
      # if date data isn't removed, Dates.formatDate will think nothing changed
      # and won't update.
      .removeData('date')
      .attr('dt', @model.get('dateLastActivity'))

      if data.mode == 'pirate'
        $badge.addClass data.agingClassesToAdd

      Dates.update(@$('.js-card-detail-age'))

    @$('.js-card-detail-age').toggleClass('hide', !agingActive)

    @

  # due date stuff
  renderDueDate: ->
    due = @model.get('due')
    dueComplete = @model.get('dueComplete')
    if !due
      @$('.js-card-detail-due-date').addClass('hide')
      return @

    text = moment(due).calendar()
    moreText = DueDateHelpers.relativeInfoForDueDate(due, dueComplete)
    if moreText?
      text += " (#{moreText})"

    classes = []
    classes.push DueDateHelpers.classForDueDate(due, dueComplete)
    if @model.editable()
      classes.push('is-clickable')

    $badge = @$('.js-card-detail-due-date-badge')
    .removeClass (index, css) ->
      # remove old badge state classes, like past, soon, future, etc.
      # http://stackoverflow.com/questions/2644299/jquery-removeclass-wildcard
      (css.match(/is-due-\S+/g) || []).join(" ")
    .addClass classes.join(' ')
    .attr 'title', DueDateHelpers.titleForDueDate(due, dueComplete)

    $badge.find('.js-date-text')
    .text(text)
    .toggleClass('js-details-edit-due-date', @model.editable())

    $badge.find('.js-card-detail-due-date-badge-complete')
    .toggleClass('js-details-toggle-due-date-complete', @model.editable())

    @$('.js-card-detail-due-date').removeClass('hide')
    @

  renderVotes: ->
    data =
      voted: @model.voted()
      canVote: @model.getBoard().canVote(Auth.me())

    # sidebar
    $voteSidebar = @$('.js-vote-sidebar-button')

    $voteSidebar.html cardDetailVoteBtnSidebarTemplate(data)

    numVotes = @model.get('badges')?.votes ? 0

    if numVotes
      @$('.js-card-detail-votes-badge')
      .text(localizeCount('votes', numVotes))
      .toggleClass('is-voted', @model.get('badges')?.viewingMemberVoted ? false)

    @$('.js-card-detail-votes').toggleClass('hide', numVotes == 0)

    @

  sortChecklists: ->
    $checklistList = @$('.js-checklist-list')
    Util.withoutAlteringSelection =>
      @model.checklistList.forEach (checklist) =>
        checklistView = @existingSubview(ChecklistView, checklist)
        $checklistList.append checklistView.el
    @

  removeChecklist: (checklist) ->
    @deleteSubview(@existingSubview(ChecklistView, checklist))

  renderChecklists: ->
    log('render', "rendering checklists")
    $checklistList = @$('.js-checklist-list').empty()

    subviews = (@subview(ChecklistView, checklist, { card: @model }) for checklist in @model.checklistList.models)
    @appendSubviews(subviews, $checklistList)

    DragSort.refreshIfInitialized($checklistList)

    if @model?.editable()
      @$('.js-checklist-list').sortable
        axis: 'y'
        handle: '.window-module-title'
        delay: 75
        distance: 7
        tolerance: 'pointer'
        placeholder: 'checklist placeholder'
        items: '.checklist'
        start: (event, ui) ->
          _height = $(ui.helper).outerHeight()
          $(ui.placeholder).height(_height)

    @

  showFewerAttachments: (e) ->
    Util.stop(e)
    @fShowAllAttachments = false
    @renderAttachments()
    return

  showMoreAttachments: (e) ->
    Util.stop(e)
    @fShowAllAttachments = true
    @renderAttachments()
    return

  showFewerTrelloAttachments: (e) ->
    Util.stop(e)
    @fShowAllTrelloAttachments = false
    @renderAttachments()
    return

  showMoreTrelloAttachments: (e) ->
    Util.stop(e)
    @fShowAllTrelloAttachments = true
    @renderAttachments()
    return

  renderAttachments: ->
    @_renderAttachmentsPromise?.cancel()

    allAttachments = _.clone(@model.attachmentList.models).reverse()

    @_renderAttachmentsPromise = Promise.all([
      Promise.all(allAttachments.map(AttachmentHelpers.getAttachmentData)),

      Promise.try =>
        PluginRunner.all
          timeout: 5000
          command: 'attachment-sections'
          card: @model
          board: @model.getBoard()
          options:
            entries: PluginModelSerializer.attachments(allAttachments)
      .cancellable()
    ])
    .spread (allAttachmentData, pluginAttachmentSections) =>
      displayedInSection = {}
      usedSubviewIds = {}

      subviews = for section in pluginAttachmentSections when section?.claimed?.length > 0
        for entry in section.claimed
          displayedInSection[entry.id] = true

        subviewId = section.id || section.title
        if _.isFunction(subviewId) || usedSubviewIds[subviewId]
          subviewId = _.uniqueId('attachment-section_')
        usedSubviewIds[subviewId] = true
        subview = @subview PluginSectionView, @model, {}, subviewId
        subview.updateSection(section)
        subview

      trelloAttachments = @getTrelloAttachments(allAttachments, allAttachmentData, displayedInSection)
      trelloAttachments.forEach(({ attachment }) -> displayedInSection[attachment.id] = true)

      idPlugins = _.chain(pluginAttachmentSections).pluck('idPlugin').uniq().value()
      for idPlugin in idPlugins
        trackUe('card details', 'views', 'Power-Up', '', '', 'attachment-sections', idPlugin)

      $pluginSections = @$('.js-plugin-sections')
      @ensureSubviews(subviews, $pluginSections)

      initialNumToShow = 4
      numShown = 0
      remainingAttachments = []

      for i, attachment of allAttachments
        if numShown == initialNumToShow or numShown == allAttachments.length
          break

        remainingAttachments.push(attachment)

        if not displayedInSection.hasOwnProperty(attachment.id)
          numShown++

      nonPluginAttachments = _.reject allAttachments, (attachment) ->
        displayedInSection[attachment.id]

      hasAttachments = numShown > 0
      hasOverflow = numShown < nonPluginAttachments.length

      $attachmentsSection = @$('.js-attachments-section')
      $trelloAttachmentsSection = @$('.js-trello-attachments-section')
      $attachmentsList = $attachmentsSection.find('.js-attachment-list')

      trelloAttachmentSubviews =
        if (processingTrelloAttachmentsCount = @numTrelloAttachmentsProcessing.get())
          _.times Math.min(3, processingTrelloAttachmentsCount), (index) =>
            @subview InProgressAttachmentView, @model, null, "processing-trello-attachment-#{ index }"
        else
          []

      if trelloAttachments.length > 0
        numHiddenTrelloAttachments = (trelloAttachments.length - initialNumToShow).toString()

        if numHiddenTrelloAttachments > 0
          if not @fShowAllTrelloAttachments
            trelloAttachments = trelloAttachments.splice(0, initialNumToShow)

            $trelloAttachmentsSection.find('.js-show-more-trello-attachments').removeClass('hide')
            $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').addClass('hide')
            $trelloAttachmentsSection.find('.js-view-all-trello-attachments').text l('view all trello attachments', {
              hiddenCount: numHiddenTrelloAttachments
            })
          else
            $trelloAttachmentsSection.find('.js-show-more-trello-attachments').addClass('hide')
            $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').removeClass('hide')
        else
          $trelloAttachmentsSection.find('.js-show-more-trello-attachments').addClass('hide')
          $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').addClass('hide')

        trelloAttachmentSubviews = trelloAttachmentSubviews.concat(
          trelloAttachments.map ({ attachment, attachmentData }) =>
            if attachmentData.type == 'trello card'
              @subview TrelloCardAttachment, attachment, { cardUrl: attachmentData.url }
            else
              @subview TrelloBoardAttachment, attachment, { boardUrl: attachmentData.url }
        )

      @ensureSubviews(trelloAttachmentSubviews, @$('.js-trello-attachments-list'))
      $trelloAttachmentsSection.toggleClass('hide', _.isEmpty(trelloAttachmentSubviews))

      @enableAttachmentSorting($attachmentsList)

      hiddenCount = (nonPluginAttachments.length - initialNumToShow).toString()
      $attachmentsSection.find('.js-view-all-attachments').text l('view all attachments', { hiddenCount })
      $attachmentsShowFewer = $attachmentsSection.find('.js-show-fewer-attachments').addClass('hide')
      $attachmentsShowMore = $attachmentsSection.find('.js-show-more-attachments').addClass('hide')

      processingSubviews =
        if (processingCount = @numAttachmentsProcessing.get())
          _.times Math.min(3, processingCount), (index) =>
            @subview InProgressAttachmentView, @model, null, "processing-#{ index }"
        else
          []

      attachmentSubviews =
        if hasAttachments
          attachmentModels = allAttachments

          if hasOverflow
            if !@fShowAllAttachments
              $attachmentsShowMore.removeClass('hide')
              attachmentModels = remainingAttachments
            else
              $attachmentsShowFewer.removeClass('hide')

          attachmentModels.map (attachment) =>
            isHidden = displayedInSection.hasOwnProperty(attachment.id)

            @subview AttachmentThumbView, attachment, {
              isHidden
              onReply: => @replyToAttachment(attachment)
              onPluginThumbnail: (idPlugin) =>
                if !@pluginThumbTrackCache[idPlugin]
                  @pluginThumbTrackCache[idPlugin] = true
                  trackUe('card details', 'views', 'Power-Up', '', '', 'attachment-thumbnail', idPlugin)
            }
        else
          []

      subviews = [processingSubviews..., attachmentSubviews...]
      @ensureSubviews(subviews, $attachmentsList)
      $attachmentsSection.toggleClass('hide', _.isEmpty(subviews))
    .catch Promise.CancellationError, (->)

    @_renderAttachmentsPromise.done()
    @

  renderEditing: ->
    members = @model.memberEditingList.models

    data =
      members: for mem in members when !Auth.isMe(mem) && mem.get('editing')?
        memberData = mem.toJSON()
        memberData.icon = switch mem.get('editing').action
          when 'commenting' then 'comment'
          when 'editing' then 'edit'
          else 'edit'
        memberData

    @$('.js-editing-members')
      .empty()
      .append editInProgressTemplate(data)
      .toggleClass('hide', data.members.length == 0)

    @

  sortStop: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('movechecklist', [ui])
    return

  sortStopAttachments: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('moveattachment', [ui])

  keydownEvent: (e) ->
    # We're overriding keydownEvent from EditableView
    super
    Auth.me().editing({
      idBoard: @model.getBoard().id
      idCard: @model.id
      action: 'editing'
    })

  keydownCommentEvent: (e) ->
    Auth.me().editing({
      idBoard: @model.getBoard().id
      idCard: @model.id
      action: 'commenting'
    })

    key = Keyboard.getKey(e)

    if key == Keys.Tab and $(e.target).hasClass('new-comment-input') and @model.editable() and !(PopOver.view instanceof AutoMentionerView) and $(e.target).val() == ""
      Util.stop(e)
      @submitComment(e)

    if Keyboard.isForceSubmitEvent(e) && !@_isCommentTooLong()
      @submitComment(e)
    else
      @checkInsert(e)

  _isCommentTooLong: ->
    @$('.js-new-comment-input').val().length > @maximumCommentLength

  renderCommentSubmitAbility: (e) ->
    isTooLong = @_isCommentTooLong()
    noInput = @$('.js-new-comment-input').val().length == 0
    isDisabled = noInput || isTooLong
    @$('.js-add-comment').prop('disabled', isDisabled)
    @$('.js-comment-subscribe').toggleClass('is-visible', !isDisabled && !@model.isSubscribed())
    @$('.comment-too-long-warning').toggleClass('is-shown', isTooLong)
    @$('.comment-too-long-warning').find('.js-attach-comment').toggle(Blob?)
    @

  renderCommentAndSubscribeBox: (e) ->
    @$('.js-comment-subscribe').toggleClass('is-subscribed')
    @

  _cancelEditing: ->
    Auth.me().editing({ idBoard: @model.getBoard().id })

  commentInputEvent: (e) ->
    @renderCommentSubmitAbility()
    @

  clearComment: ->
    $input = $(@commentInput)

    $input
    .val('')
    .css('height', '') # In case they resized the textarea

    @renderCommentSubmitAbility()

  submitComment: (e) ->
    track("Card Detail", "Comment", "Submit Comment")
    Util.stop(e)

    $input = $(@commentInput)
    text = $input.val()

    @clearComment()

    @_cancelEditing()
    @model.addComment(text)

    if Auth.me().isSubscribeOnCommentEnabled() &&
      !@model.isSubscribed() &&
      getExperiment('commentAndSubscribe').get('enabled')
        @model.subscribe(true)

    Layout.cancelEdits()
    @collapseComment()
    @renderCommentSubmitAbility()

    PopOver.hide()

    false

  subscribeOnComment: (e) ->
    Util.stop(e)

    me = Auth.me()

    if !me.isSubscribeOnCommentEnabled()
      track("Card Detail", "Comment and Subscribe", "Enable")
    else
      track("Card Detail", "Comment and Subscribe", "Disable")

    @renderCommentAndSubscribeBox()

    me.toggleSubscribeOnComment()

    false

  clearEdits: ->
    @_cancelEditing()
    super

  commitEdits: ->
    @_cancelEditing()
    super

  stopEditing: ->
    @_cancelEditing()
    super

  truncateComment: (e) ->
    $comment = @$('.js-new-comment-input')
    $comment.val($comment.val().substr(0, @maximumCommentLength))
    @$('.js-new-comment-input').autosize()
    @renderCommentSubmitAbility()

  attachComment: (e) ->
    file = new Blob([@$('.js-new-comment-input').val()], { type: 'text/plain' })
    @incrementNumAttachmentsProcessing()
    @model.upload file, 'comment.txt', @callback =>
      @decrementNumAttachmentsProcessing()

    @clearComment()
    Layout.cancelEdits()
    @collapseComment()

  inputComment: (e) ->
    $comment = @$('.js-new-comment')
    Layout.cancelEdits(@commentInput)
    $comment.addClass('is-focused')
    return

  clickAwayFromComment: (e) ->
    # If there's a popover open, and someone "clicks away," they're
    # *probably* trying to dismiss the popover, not the comment box.
    if PopOver.isVisible
      return

    # We want to distinguish between "a click on the background" and
    # "a click on a comment-related button" (like "Mention Member"), so
    # that we don't infuriatingly close the comment box while the user
    # is trying to do something. "Having no children" is a bit clever,
    # but it's a concise way of distinguishing between "background
    # elements" and "foreground" elements, like buttons.
    el = e.target
    $comment = @$('.js-new-comment')
    if $(el).closest($comment).length && el.children.length == 0
      return

    @collapseComment()

  collapseComment: ->
    @$('.js-new-comment').removeClass('is-focused')

  replyToAction: (e, action) ->
    memberCreator = @modelCache.get('Member', action.get('idMemberCreator'))
    username = memberCreator?.get('username')

    $comment = @$(@commentInput)

    replyText =
      if action.isCommentLike() && username?
        Layout.cancelEdits(@commentInput)
        # Only add the @mention if they haven't already added one; maybe they
        # clicked 'reply' twice or something
        if ///@#{ username }(\W|$)///.test($comment.val())
          $comment.focus()
          null
        else
          "@#{username} "
      else if action.isAddAttachment() && (attachment = @model.attachmentList.get(action.get('data').attachment?.id))?
        attachmentMarkdown = attachmentAsMarkdown(attachment)
        if Auth.isMe(memberCreator)
          attachmentMarkdown
        else
          ["@#{ username }", attachmentMarkdown].join(' ')

    if replyText
      $comment.addClass('is-focused')
      Util.insertSelection($comment, replyText)
      $comment.trigger('autosize.resize')

    return

  replyToAllAction: (e, action) ->
    memberCreator = @modelCache.get('Member', action.get('idMemberCreator'))
    username = memberCreator?.get('username')

    # Cache the current values for comment
    $comment = @$(@commentInput)
    commentText = $comment.val()

    mentionsFromText = (markdown) ->
      _.uniq(TFM.comments.getMatches(markdown, { 'atMention': true }).atMention)

    mentions = _.chain(mentionsFromText(action.get('data').text))
      .concat("@#{ username }")
      .uniq((a) -> a.toLowerCase())
      .without(
        "@#{ Auth.myUsername() }",
        mentionsFromText(commentText)...
      )
      .value()

    # Tracking for @card then remove them
    if(_.contains(mentions, '@card') || _.contains(mentions, '@board'))
      track("Card", "Reply to all with a @card or @board mention")

    mentions = _.without(mentions, '@card', '@board')

    # Track how many users have been added
    track("Card", "Reply to all Comment Mention Count", mentions.length)

    if mentions.length
      replyText = mentions.join(" ") + " "
      $comment.addClass('is-focused')
      Util.insertSelection($comment, replyText)
      $comment.trigger('autosize.resize')
    else
      $comment.focus()

    return

  replyToAttachment: (attachment) ->
    Layout.cancelEdits(@commentInput)
    $comment = @$(@commentInput)
    $comment.addClass('is-focused')
    Util.insertSelection($comment, attachmentAsMarkdown(attachment))
    $comment.trigger('autosize.resize')

  getCard: ->
    @model

  getTextInput: ->
    @$('.js-new-comment-input')

  getMentionTarget: ->
    @$('.js-comment-mention-member:visible')[0]

  getEmojiTarget: ->
    @$('.js-comment-add-emoji:visible')[0]

  # edit members
  openEditMembersPopOver: (elem) ->
    PopOver.toggle
      elem: elem
      view: CardMemberSelectView
      options: { @model, @modelCache }
    return

  editMembersMain: (e) ->
    Util.stop(e)
    @openEditMembersPopOver(@$('.js-details-edit-members'))
    track("Card Detail", "Edit Members via Main Column")
    return

  changeMembersSidebar: (e) ->
    Util.stop(e)
    @openEditMembersPopOver(@$('.js-change-card-members'))
    track("Card Detail", "Sidebar", "Open Manage Member Menu")
    return

  addChecklistSidebar: (e) ->
    Util.preventDefault(e)

    PopOver.toggle
      elem: e.target
      view: AddChecklistMenu
      options: { @model, @modelCache, cardView: @ }

    track('Card Detail', "Add Checklist Button", "Open Add Checklist Menu")
    false

  showDueDateBadgeMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-details-edit-due-date')
      view: DatePickerView
      options: { @model, @modelCache }

    track("Card Detail", "Due Date Badge", "Open Due Date Menu")
    return

  toggleDueDateComplete: (e) ->
    newValue = !@model.get('dueComplete')
    @model.update({
      dueComplete: newValue
    })
    track("Card Detail", "Due Date Badge", if newValue then "Marked Complete" else "Marked Incomplete")

  openAttachPicker: (e) ->
    Util.stop(e)

    elem = $(e.target).closest('.js-attach')

    PopOver.toggle
      elem: elem
      view: AttachmentTypePickerView
      options: { @model, @modelCache }

    type = if $(elem).hasClass('inline')
      "Inline"
    else
      "Sidebar"
    track("Card Detail", "Open Attachment Type Picker", "Via #{type} Button")

    false

  openAttachTrelloPicker: (e) ->
    Util.stop(e)

    elem = $(e.target).closest('.js-attach-trello-attachment')
    track("Card Detail", "Open Trello Attachment Picker", "Via Trello Attachments Section")

    PopOver.toggle
      elem: elem
      view: TrelloCompleterView
      options: {
        @model
        @modelCache
        card: @model
        button: true
        callback: (card) =>
          url = card.get('url')
          Promise.fromNode (next) => @model.uploadUrl(url, next)
          .catch LimitExceeded, =>
            Alerts.show("unable to attach card or board", 'error', 'trelloattachment', 5000)
          .then ->
            PopOver.popView()
      }

    false

  dueDateSidebar: (e) ->
    Util.preventDefault(e)

    PopOver.toggle
      elem: @$('.js-add-due-date')
      view: DatePickerView
      options: { @model, @modelCache }

    track("Card Detail", "Sidebar", "Open Due Date Menu")
    false

  subscribeToCard: (e) ->
    @model.subscribe(true)
    track("Card Detail", "Sidebar", "Subscribe")
    @renderCommentSubmitAbility()
    false

  unsubscribeFromCard: (e) ->
    @model.subscribe(false)
    track("Card Detail", "Sidebar", "Unsubscribe")
    @renderCommentSubmitAbility()
    false

  vote: (e) ->
    Util.preventDefault(e)
    @model.vote(true)
    track("Card Detail", "Sidebar", "Vote")
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', LegacyPowerUps.voting)
    false

  unvote: (e) ->
    Util.preventDefault(e)
    track("Card Detail", "Sidebar", "Unvote")
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', LegacyPowerUps.voting)
    @model.vote(false)
    false

  openFormatHelp: (e) ->
    track("Card Detail", "Formatting Help")

    PopOver.toggle
      elem: @$('.js-format-help')
      view: FormattingHelpView
      options: { @model, @modelCache }
      # use keepEdits so the editable field doesn't close
      # and hide $('.js-format-help'), which we bind to
      keepEdits: true

    false

  dragenter: (e) ->
    if !@model.editable()
      return

    limited = !@model.canAttach()
    _scrollTop = $('.window-overlay').scrollTop() + 200

    className = if limited then '.dropzone-limited' else '.dropzone'
    @$(className).css
      'padding-top': "#{_scrollTop}px"
    @$el
    .addClass('is-drophover')
    .toggleClass('is-limited', limited)

  dragleave: (e) ->
    @$el.removeClass('is-drophover')

  dropFiles: (e) ->
    if !@model.canAttach()
      return

    track("Card Detail", "Drop Attachment Upload")
    files = e.detail

    if warnIfFileTooLarge(@model.getBoard(), files)
      return

    @incrementNumAttachmentsProcessing(files.length)

    processed = 0
    Promise.resolve(files)
    .each (file) =>
      name = file.name || pastedFileName()
      ninvoke @model, 'upload', file, name
      .finally @callback =>
        processed++
        @decrementNumAttachmentsProcessing()
    .catch ->
      Alerts.show("unable to upload file", 'error', 'upload', 5000)
    .finally =>
      if processed != files.length
        @decrementNumAttachmentsProcessing(files.length - processed)
    .done()

    e.stopPropagation()

  dropUrl: (e) ->
    if !@model.canAttach()
      return

    track("Card Detail", "Drop Attachment Url")
    url = e.detail

    isTrelloAttachment = parseTrelloUrl(url).type in ['board', 'card']

    if isTrelloAttachment
      @incrementNumTrelloAttachmentsProcessing()
    else
      @incrementNumAttachmentsProcessing()

    @model.uploadUrl url, @callback =>
      if isTrelloAttachment
        @decrementNumTrelloAttachmentsProcessing()
      else
        @decrementNumAttachmentsProcessing()
    e.stopPropagation()

  focusChecklistAdd: (checklist) ->
    @existingSubview(ChecklistView, checklist).focusNewTaskInput()

  closeDialog: ->
    Dialog.hide()

  highlight: (highlight, scrollIntoView) ->
    if (parts = /^([a-z]+)-([a-f0-9]{24})$/.exec(highlight))?
      [all, type, id] = parts
      switch type
        when 'action', 'comment'
          @actionListView.setHighlight(id)
          if !@model.actionList.get(id)
            @showAllActions()
          if scrollIntoView
            @scrollToHighlight()

    return

  replyToComment: (replyToComment) ->
    if @model.getBoard().canComment(Auth.me()) && replyToComment
      $newCommentInput = @$('.js-new-comment-input')
      $newCommentInput.val("@#{replyToComment} ")
      $newCommentInput.focus()
      Util.setCaretAtEnd($newCommentInput[0])

    @renderCommentSubmitAbility()

    return

  # If the user clicks on a link that points to something on the card we're
  # already looking at, don't do the whole navigation thing and instead just
  # skip to running the highlight code
  interceptHighlightLink: (e) ->
    # So I'm not sure how exactly this happens, given that we've selected
    # for a[href], but we are getting error reports that indicate that
    # e.target.href is undefined sometimes
    if !e.target.href
      return

    url = Util.relativeUrl(e.target.href)
    cardUrl = Controller.getCardUrl(@model)
    if (parts = ///^ #{cardUrl} \# ([^\#]+) $///.exec(url))?
      [all, highlight] = parts
      if highlight
        Util.stop(e)

        # Toggle the hash off if we're already on this one
        if highlight == location.hash.substr(1)
          history.replaceState(null, null, location.pathname)
          @actionListView.setHighlight(null)
        else
          history.replaceState(null, null, location.pathname + "#" + highlight)
          @highlight(highlight, true)
    return

  showDetails: (e) ->
    Util.stop(e)
    Auth.me().setShowDetails(true)
    @getData()
    @renderActionList()

  hideDetails: (e) ->
    Util.stop(e)
    Auth.me().setShowDetails(false)
    @getData()
    @renderActionList()

  enableAttachmentSorting: ($attachmentsList) ->
    if @model?.editable()
      $attachmentsList.sortable
        axis: 'y'
        handle: [
          '.attachment-thumbnail-details'
          '.attachment-thumbnail-preview'
        ].join(',')
        delay: 75
        distance: 7
        tolerance: 'pointer'
        helper: 'clone'
        placeholder: 'attachment-thumbnail placeholder'
        items: '.attachment-thumbnail'
        start: (event, ui) ->
          _height = $(ui.helper).outerHeight()
          $(ui.placeholder).height(_height)

  getTrelloAttachments: (attachments, allAttachmentData, claimedAttachments) ->
    attachmentTypes = ['trello board', 'trello card']

    attachments.map((attachment, i) =>
      attachmentData = allAttachmentData[i]
      if attachmentData.isKnownService and attachmentData.type in attachmentTypes and !claimedAttachments[attachment.id]
        { attachment, attachmentData }
      else
        null
    ).filter((a) => a != null)



// WEBPACK FOOTER //
// ./app/scripts/views/card/card-detail-view.coffee